import type { Node } from "interfaces/schemas";
import * as identify from "utils/treeUtils";

export const isNodeVisibilityClickable = (node: Node): boolean =>
  identify.isWizardRootFolder(node) ||
  identify.isTroxNetcomFolderRoot(node) ||
  identify.isFolder(node) ||
  identify.isRoot(node) ||
  identify.isCustomProduct(node) ||
  identify.isProduct(node);
